// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"caac85ce","838":"a6397857"}[chunkId] + ".chunk.js";
};